import React from "react";

// Parent brand — HR ENTERPRISES (master identity)
export const HR_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_hr-enterprises/artifacts/kaa6dvuw_image.png";

// Flagship technology division — AURIX STUDIO (horse mark)
export const AURIX_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_hr-enterprises/artifacts/ak2ygai3_WhatsApp%20Image%202026-07-07%20at%2022.36.28.jpeg";

/* ---------- Parent brand (HR ENTERPRISES) ---------- */
export const HRMark = ({ size = 40, className = "" }) => (
  <div
    className={`relative shrink-0 overflow-hidden rounded-md ${className}`}
    style={{ width: size, height: size }}
    aria-label="HR ENTERPRISES logo"
  >
    <img
      src={HR_LOGO_URL}
      alt="HR ENTERPRISES"
      width={size}
      height={size}
      className="h-full w-full object-cover"
      loading="eager"
      decoding="async"
    />
  </div>
);

export const HRWordmark = ({ withMark = true, size = 36 }) => (
  <div className="flex items-center gap-3">
    {withMark && <HRMark size={size} />}
    <div className="flex flex-col leading-none">
      <span className="font-display text-[15px] font-semibold tracking-tight text-white">
        HR <span className="gold-gradient-text">ENTERPRISES</span>
      </span>
      <span
        className="font-mono-label mt-1 text-[9px] text-zinc-500"
        style={{ letterSpacing: "0.32em" }}
      >
        PARENT · COMPANY
      </span>
    </div>
  </div>
);

export const HRLogoFull = ({ className = "" }) => (
  <img
    src={HR_LOGO_URL}
    alt="HR ENTERPRISES"
    className={className}
    loading="lazy"
    decoding="async"
  />
);

/* ---------- Flagship division (AURIX STUDIO horse) ---------- */
export const AurixMark = ({ size = 40, className = "" }) => (
  <div
    className={`relative shrink-0 overflow-hidden rounded-md ${className}`}
    style={{ width: size, height: size }}
    aria-label="AURIX STUDIO logo"
  >
    <img
      src={AURIX_LOGO_URL}
      alt="AURIX STUDIO"
      width={size}
      height={size}
      className="h-full w-full object-cover"
      loading="lazy"
      decoding="async"
    />
  </div>
);

export const AurixLogoFull = ({ className = "" }) => (
  <img
    src={AURIX_LOGO_URL}
    alt="AURIX STUDIO — Flagship technology division of HR ENTERPRISES"
    className={className}
    loading="lazy"
    decoding="async"
  />
);

/* Back-compat alias so any existing imports still work */
export const AurixWordmark = HRWordmark;

export default HRWordmark;
